import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { Outlet } from "react-router-dom";
import logo from "./logo.svg";
import "./App.css";
import "./css/post-18.css";
import "./css/rbt-modules.css";
import "./css/custom-frontend.min.css";
import "./css/elementor.min.css";
import "./css/startpro-core.min.css";
import "./css/elegant-icons.min.css";
import "./css/all.min.css";
import "./css/animate.min.css";
import "./css/startpro-membership.min.css";
import "./css/brands.css";
import "./css/gird.min.css";
import "./css/grid.css";
import "./css/helper-parts.min.css";
import "./css/main.css";
import "./css/main.min.css";
import "./css/styles.css";
import "./css/post-4.css";
import "./assets/main.min.css";
import "./css/post-3563.css";
import Logo from "./component/Logo";
import Navigation from "./component/Navigation";
import Widgets from "./component/Widgets";
import MobileHeader from "./component/MobileHeader";
import MainContainer from "./component/MainContainer";
import Footer from "./component/Footer";
import RouterIndex from "./pages/RouterIndex";
import Toolbar from "./component/Toolbar";
import DynamicStyles from "./pages/DynamicStyles";
import MobileNavigation from "./component/MobileNavigation";
import QodefBackgroundText from "./component/QodefBackgroundText";
import Lottie from "lottie-react";
import loaderAnimation from "./assets/loader.json";

function App() {
  // useEffect(() => {
  //   AOS.init({
  //     disable: function () {
  //       return window.innerWidth < 768; // Disable AOS on screens smaller than 768px
  //     }
  //   });
 

  // }, []);
useEffect(() => {
  AOS.init({
    once: true,           
    duration: 600,        
    easing: 'ease-out',    
    disable: false         
  });

  AOS.refresh();          

}, []);
  const isMobile = window.location.pathname !== "/";
    const [loading, setLoading] = React.useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000); 
  }, []);

  return (
    <div className="home page-template page-template-page-full-width page-template-page-full-width-php page page-id-18 theme-startpro qi-blocks-1.3.4 qodef-gutenberg--no-touch qode-framework-1.2.4 woocommerce-no-js qodef-qi--no-touch qi-addons-for-elementor-1.8.3 qodef-back-to-top--enabled  qodef-content-behind-header qodef-header--standard qodef-header-appearance--sticky qodef-content--behind-header qodef-mobile-header--standard qodef-drop-down-second--full-width qodef-drop-down-second--default startpro-core-1.0 startpro-membership-1.0 startpro-1.0 qodef-content-grid-1300 qodef-header-standard--left qodef-search--covers-header elementor-default elementor-kit-4 elementor-page elementor-page-18" style={{overflow:"hidden"}}>
         {loading ? (
      <div className="loader"> <Lottie animationData={loaderAnimation} loop={true} style={{ width: 250, height: 250 }} /></div> // Replace with an actual loader/spinner
    ) : (
      <div id="qodef-page-wrapper">
        <header id="qodef-page-header" role="banner">
          <div id="qodef-page-header-inner">
            <a

              className="qodef-header-logo-link qodef-height--set qodef-source--image"
              href="/"
              rel="home"
            >
              <img
                // loading="lazy"
                width="296px"
                height="58px"
                style={{ height: "47px", objectFit: "cover" }}
                src="/img/pmclogo.png"
                className="qodef-header-logo-image qodef--main"
                alt="Main Logo"

              />
              <img
                // loading="lazy"
                width="296"
                height="68"
                style={{ height: "47px", objectFit: "cover" }}
                src="/img/pmclogo.png"
                className="qodef-header-logo-image qodef--dark"
                alt="Dark Theme Logo"

              />
              <img
                // loading="lazy"
                width="296"
                height="68"
                style={{ height: "47px", objectFit: "cover" }}
                src="/img/pmclogo.png"
                className="qodef-header-logo-image qodef--light"
                alt="Light Theme Logo"

              />
            </a>
            <Navigation />
            {/* <nav
              className="qodef-header-navigation"
              role="navigation"
              aria-label="Top Menu"
            >
              <ul className="menu">
                <li className="menu-item menu-item-has-children qodef-menu-item--wide">
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    <span className="qodef-menu-item-text">
                      Home
                      <svg
                        className="qodef-svg--menu-arrow qodef-menu-item-arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        width="12.643"
                        height="12.642"
                        viewBox="0 0 12.643 12.642"
                      >
                        <g fill="none" stroke="currentColor">
                          <path d="m5.968.353 5.968 5.968-5.968 5.967" />
                          <path d="M11.935 6.32H0" />
                        </g>
                      </svg>
                    </span>
                  </a>
                  <div className="qodef-drop-down-second">
                    <div className="qodef-drop-down-second-inner">
                      <ul className="sub-menu">
                        {menuItems.map((item, index) => (
                          <li key={index} className="menu-item">
                            <div className="qodef-mega-menu-widget-holder">
                              <div className="widget" data-area="header-menu">
                                <div className="qodef-shortcode qodef-image-with-text">
                                  <div className="qodef-m-image">
                                    <a href={item.link} target="_self">
                                      <img
                                        loading="lazy"
                                        width="850"
                                        height="477"
                                        src={item.imgSrc}
                                        alt={item.alt}
                                      />
                                    </a>
                                  </div>
                                  <div className="qodef-m-content">
                                    <span className="qodef-m-title">
                                      <a href={item.link} target="_self">
                                        {item.title}
                                      </a>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </nav> */}
            <div className="qodef-widget-holder qodef--one">
              {/* Free Consultation Button */}
              <div
                id="startpro_core_button-5"
                className="widget widget_startpro_core_button qodef-header-widget-area-one"
                data-area="header-widget-one"
              >
                <a
                  className="qodef-shortcode qodef-m qodef-button qodef-layout--filled qodef-html--link"
                  href="/contact_us"
                  target="_self"
                >
                  <span className="qodef-m-text">Book consultation</span>
                </a>
              </div>

              {/* Sign-up Link */}
              {/* <div
                id="startpro_membership_login_opener-2"
                className="widget widget_startpro_membership_login_opener qodef-header-widget-area-one"
                data-area="header-widget-one"
              >
                <div className="qodef-login-opener-widget qodef-user-logged--out">
                  <a href="#" className="qodef-login-opener">
                    <span className="qodef-m-text">Sign up</span>
                  </a>
                </div>
              </div> */}
            </div>
          </div>
          <div className="qodef-header-sticky qodef-custom-header-layout qodef-appearance--down">
            <div className="qodef-header-sticky-inner">
              <div className="qodef-header-sticky-wrapper">
                <Logo />
                <Navigation />
                {/* <Widgets /> */}
              </div>
            </div>
          </div>
        </header>
        {/* <MobileHeader /> */}
        <div>
          <div id="qodef-page-outer">
            <div id="qodef-page-inne" className="qodef-content-full-width">
              <main
                id="qodef-page-content"
                className="qodef-grid qodef-layout--template qodef-grid-template--12 "
                role="main"
              >
                <div className="qodef-grid-inner">
                  <div className="qodef-grid-item qodef-page-content-section qodef-col--content">

                    {/* <BrowserRouter> */}
                    <DynamicStyles />
                    <MobileHeader />

                    <Outlet />
                    {/* </BrowserRouter>, */}
                  </div>
                </div>
              </main>
            </div>
          </div>
          {isMobile && (<div id="qodef-page-content-bottom" className="qodef-m" role="contentinfo">
            <div className="qodef-m-inner qodef-content-grid">
              <div className="qodef-cta">
                <h3 className="qodef-e-title text-divider" style={{ color: "#fff" }}>Get started with PMC</h3>
                <a
                  className="qodef-shortcode qodef-m  qodef-button qodef-layout--filled  qodef-html--link "
                  href="/contact_us"
                  target="_self"
                  style={{ color: "#000",background:"#fff" }}
                >
                  {" "}
                  <span className="qodef-m-text">Free consultation</span>
                </a>{" "}
              </div>
            </div>
          </div>)}

        </div>

        <Footer />
        <QodefBackgroundText />

        {/* <Toolbar /> */}
      </div>)}
    </div>
  );
}

export default App;
